var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductivityBoostIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FDF4E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 52.7349C47.0416 52.7349 52.75 47.0265 52.75 39.9849C52.75 32.9432 47.0416 27.2349 40 27.2349C32.9584 27.2349 27.25 32.9432 27.25 39.9849C27.25 47.0265 32.9584 52.7349 40 52.7349Z",
    stroke: "#38CB89",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8303 24.8025L24.8302 24.8023L24.8303 27.8025M39.9996 23.485V18.985V23.485ZM37.8783 20.6405L39.9996 18.519L42.1209 20.6405H37.8783ZM56.4862 39.9717H60.9862H56.4862ZM59.3308 37.8504L61.4523 39.9717L59.3308 42.093V37.8504ZM23.5129 39.9717H19.0129H23.5129ZM20.6683 37.8504L18.5469 39.9717L20.6683 42.093V37.8504ZM51.6574 28.3139L54.8394 25.1319L51.6574 28.3139ZM52.1688 24.8025L55.1689 24.8023L55.1688 27.8025L52.1688 24.8025ZM28.3418 51.6295L25.1598 54.8115L28.3418 51.6295ZM24.8303 52.1409L24.8302 55.1411L27.8304 55.1409L24.8303 52.1409ZM51.6574 51.6295L54.8394 54.8115L51.6574 51.6295ZM55.1688 52.1409L55.1689 55.1411L52.1688 55.1409L55.1688 52.1409ZM28.3418 28.3139L25.1598 25.1319L28.3418 28.3139Z",
    stroke: "#38CB89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1504 29.4712C37.3656 29.4712 34.6949 30.5775 32.7258 32.5466C30.7566 34.5158 29.6504 37.1864 29.6504 39.9712C29.6522 40.2715 29.6668 40.5716 29.6943 40.8706C30.1482 47.665 35.6035 49.2551 35.6035 53.612H36.7988C36.1435 53.7728 35.6504 54.3353 35.6504 55.0417V61.0417C35.6504 61.8727 36.3194 62.5417 37.1504 62.5417H43.1504C43.9814 62.5417 44.6504 61.8727 44.6504 61.0417V55.0417C44.6504 54.3353 44.1573 53.7728 43.502 53.612H44.6973C44.6973 49.2872 50.0744 47.6887 50.5977 41.02C50.6327 40.6715 50.6503 40.3215 50.6504 39.9712C50.6504 37.1864 49.5441 34.5158 47.575 32.5466C45.6059 30.5775 42.9352 29.4712 40.1504 29.4712Z",
    fill: "#FFAB00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6504 53.6118V55.0415V61.0415C35.6504 61.8725 36.3194 62.5415 37.1504 62.5415H43.1504C43.9814 62.5415 44.6504 61.8725 44.6504 61.0415V55.0415V53.6118H35.6504Z",
    fill: "#576D7E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9121 60.2915H45.389M34.9121 54.2915H45.389H34.9121ZM34.9121 57.2915H45.389H34.9121Z",
    stroke: "#2B4255",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityBoostIcon);
export default __webpack_public_path__ + "static/media/productivityBoostIcon.b1b3e4ba.svg";
export { ForwardRef as ReactComponent };